export default "__VITE_ASSET__BQPEK851__"